import React from "react";
import cn from "clsx";
import ReactHtmlParser from "react-html-parser";

const defaultToggleImage = () => <div className="toggleImage" />;

const DropdownLabel = ({ data, item, readonly }) => {
  if (item?.labelElement) return item.labelElement;

  return (
    <span className={cn({ expiry_details: item?.value })}>
      <div
        className={cn({
          "read-only-prefix": readonly,
          expiry_details_content_container: item?.value && !readonly
        })}
      >
        {ReactHtmlParser(item?.label)}
      </div>
      {data?.length > 0 && defaultToggleImage()}
    </span>
  );
};

export default DropdownLabel;
